import ConditionVariantizer from "./ConditionVariantizer.js";
import ConditionVariantizerEditor from "./ConditionVariantizerEditor.js";
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: ConditionVariantizer.TYPE,
      model: ConditionVariantizer
    });
    molten.addPlugin('ModelEditor', {
      type: ConditionVariantizer.TYPE,
      editor: ConditionVariantizerEditor
    });
    molten.addPlugin('Variantizer', {
      type: ConditionVariantizer.TYPE,
      name: 'Conditional Variant',
      variantizer: ConditionVariantizer
    });
  }
};